<template>
  <section>
   <!-- <div class="centered">
      <v-layout wrap>
        <v-flex md12>
          <v-icon
          size="135"
          color="light-blue darken-4"
          >
            account_circle
          </v-icon>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex md12>
          <v-btn
            class="el-button-login-success"
            @click="dialogVisible = true; crearImagenCaptcha()"
            type="success">
            Ingresar con Cuenta de DJBR
          </v-btn>
        </v-flex>
      </v-layout>
    </div> -->
    <v-btn v-if="alerta === false" small flat color="primary" @click.stop='dialogVisible = true; crearImagenCaptcha()'>
      <p style="color:white;"><v-icon>person</v-icon>&nbsp;<b>Ingresar con cuenta de DJBR</b></p>
    </v-btn>
    <v-dialog v-model="dialogVisible" scrollable persistent max-width="750">
      <v-card>
        <v-toolbar dark color="primary">
          <v-card-title><h4>Ingresar con Cuenta DJBR</h4></v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="cancelar()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <br>
          <v-form v-model='valid' ref='formCuenta' lazy-validation>
            <v-layout row wrap>
              <v-flex md8 offset-md2>
                <v-text-field
                  v-model="form.cueperdec_login"
                  :rules='cuentaRules'
                  prepend-icon="fingerprint"
                  label='Cuenta de Usuario'
                  required
                  maxlength='12'
                ></v-text-field>
              </v-flex>
              <v-flex md8 offset-md2>
                <v-text-field
                  v-model="form.cueperdec_contrasenia"
                  :rules='passRule'
                  label='Contraseña'
                  class="text-normal"
                  required
                  maxlength='20'
                  prepend-icon="security"
                  type = 'password'
                ></v-text-field>
              </v-flex>
            </v-layout>
            <p>Digite la letras y/o números que aparecen en la imagen </p>
            <v-layout row wrap>
              <v-flex md3 offset-md1>
                <img
                  :src="imgb64"
                  alt="Bolivia">
              </v-flex>
              <v-flex md3 offset-md1>
                <v-text-field
                  v-model="form.captcha"
                  label='Respuesta'
                  :rules='this.useCaptcha ? dRules : []'
                  :required="this.useCaptcha"
                  :maxlength="this.lengthCaptcha"
                  @keydown.enter="login()"
                ></v-text-field>
              </v-flex>
              <v-flex md1>
                <v-icon large @click="crearImagenCaptcha()">cached</v-icon>
              </v-flex>
            </v-layout>
          </v-form>
          <v-layout>
            <a @click="cancelar(), $router.push('/password')">¿Has olvidado tu cuenta?</a>
          </v-layout>
          <v-layout>
            <a @click="cancelar(), $router.push('crear-cuenta')"> ¿No tienes una cuenta? Regístrate </a>
          </v-layout>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" :loading="loadingB" @click="login()"><v-icon>how_to_reg</v-icon>&nbsp;Ingresar</v-btn>
            <v-btn color="error" :disabled="loadingB" @click="cancelar()"><v-icon>cancel</v-icon>&nbsp;Cancelar</v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
  </section>
</template>
<script>
import Captcha from '../mixins/captcha.js';
export default {
  mixins: [ Captcha ],
  props: {
    alerta: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      valid: true,
      dialogVisible: false,
      form: {
        cueperdec_login: '',
        cueperdec_contrasenia: '',
        captcha: ''
      },
      dRules: [v => !!v || 'Este campo es requerido'],
      passRule: [v => !!v || 'Este campo es requerido', v => v.length > 7 || 'Debe tener al menos 8 caracteres'],
      cuentaRules: [v => !!v || 'Este campo es requerido', v => v.length > 9 || 'El tamaño de la cuenta no es valida'],
      imgb64: '',
      tokenCaptcha: '',
      useCaptcha: process.env.USE_CAPTCHA,
      lengthCaptcha: process.env.LENGTH_CAPTCHA,
      loadingB: false
    };
  },
  created () {
    if (this.alerta === true) {
      this.dialogVisible = this.alerta;
    }
    this.crearImagenCaptcha();
  },
  methods: {
    async crearImagenCaptcha () {
      this.form.captcha = '';
      let result = await this.makeText();
      this.tokenCaptcha = result.token;
      this.imgb64 = this.generateCaptcha(result.captcha);
    },
    login () {
      if (this.$refs.formCuenta.validate()) {
        // let verify = this.verificarCaptcha(this.useCaptcha, this.tokenCaptcha, this.form.captcha);
        // if (verify) {
        this.loadingB = true;
        this.form.token = this.tokenCaptcha;
        this.$service.post(`control_tarjeta/login_cuenta`, this.form)
        .then(response => {
          window.localStorage.setItem('djbr_ingreso', 1);
          let url = `${response.url}?data=${response.token}`;
          this.dialogVisible = false;
          window.location.href = url;
          this.loadingB = false;
        }).catch(error => {
          console.log(error);
          this.crearImagenCaptcha();
          this.loadingB = false;
        });
        // } else {
        //   this.crearImagenCaptcha();
        //   this.loadingB = false;
        //   this.$message['warning']('La operación de verificación no es correcta.');
        // }
      } else {
        this.crearImagenCaptcha();
        this.loadingB = false;
        this.$message['warning']('Por Favor complete los datos requeridos..');
      }
    },
    cancelar () {
      this.dialogVisible = false;
      this.form = { cueperdec_login: '', cueperdec_contrasenia: '', captcha: '' };
      this.$refs.formCuenta.resetValidation();
    }
  }
};
</script>
<style lang="scss">
.alert {
  padding: 20px;
  background-color: #0288D1;
  color: white;
}
.centered {
  text-align: center;
  h2 {
    color: #01579B;
  }
  line-height: 1;
}
.el-button-login-success {
  width: 250px !important;
  color: white !important;
  background-color: #8BC34A !important;
}
.el-button-login-primary {
  width: 250px !important;
  color: white !important;
  background-color: #01579B !important;
}
.el-button-login-default {
  width: 250px !important;
  color: white !important;
  background-color: #898b96 !important;
}
.b-login-dialog {
  .el-dialog {
    width: 92%;
    max-width: 820px;
  }
}
.app-login_djbr {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 100%;
  position: relative;
  z-index: 1001;
  .el-form {
    width: 500px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/portal/login/LoginDjbr.vue